import React, { useState, useEffect } from "react";
import "./Facilities.css";
import { imageStorage } from "../../utils/storage";

const Facilities = () => {
  const [galleryItems, setGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGallery = async () => {
      try {
        const storedImages = await imageStorage.getAllImages();
        
        // If no images exist in storage, use sample data and save to storage
        if (storedImages.length === 0) {
          const sampleImages = [
            { 
              id: 1,
              title: "Boys Hostel", 
              url: "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=400&h=300&fit=crop",
              category: "Hostel"
            },
            { 
              id: 2,
              title: "Girls Hostel", 
              url: "https://images.unsplash.com/photo-1599809275771-0a8d0c83ba9a?w=400&h=300&fit=crop",
              category: "Hostel"
            },
            { 
              id: 3,
              title: "Mosque", 
              url: "https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?w=400&h=300&fit=crop",
              category: "Campus"
            },
            { 
              id: 4,
              title: "Modern Classrooms", 
              url: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=400&h=300&fit=crop",
              category: "Facilities"
            },
            { 
              id: 5,
              title: "Library & Study Area", 
              url: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=400&h=300&fit=crop",
              category: "Facilities"
            },
            { 
              id: 6,
              title: "Sports & Activities", 
              url: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
              category: "Facilities"
            },
          ];
          
          // Save sample images to storage
          for (const image of sampleImages) {
            await imageStorage.saveImage(image);
          }
          
          setGalleryItems(sampleImages);
        } else {
          setGalleryItems(storedImages);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error loading gallery:', error);
        setLoading(false);
      }
    };

    setTimeout(loadGallery, 500);

    // Listen for storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'alasar_images') {
        console.log('Gallery storage changed, reloading...');
        loadGallery();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  if (loading) {
    return (
      <section className="gallery-section">
        <div className="gallery-overlay">
          <div className="gallery-loading">
            <div className="loading-spinner"></div>
            <p>Loading gallery...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="gallery-section">
      <div className="gallery-overlay">
        <h1 className="gallery-title">Campus Gallery</h1>
        <p className="gallery-subtitle">
          Explore our beautiful campus, hostels, and facilities.
        </p>

        <div className="gallery-grid">
          {galleryItems.map((item) => (
            <div className="gallery-item" key={item.id}>
              <img src={item.url} alt={item.title} className="gallery-img" />
              <div className="gallery-caption">
                <h4>{item.title}</h4>
                <span className="gallery-category">{item.category}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Facilities;
